export { default } from "./Tabs";
export { default as rehydrator } from "./Tabs.rehydrator";
export { default as panelRehydrator } from "./components/Panel/Panel.rehydrator";